import en from './en';
import zhTW from './zh-TW';

module.exports = {
	en,
	'zh-TW': zhTW,
};



// WEBPACK FOOTER //
// ./src/util/resources/index.js